import { Grid } from '@mui/material';
import { useEffect } from 'react';
import Asunto from '../../components/Form/Fields/Asunto';
import CorreoOriginal from '../../components/Form/Fields/CorreoOriginal';
import Destinatario from '../../components/Form/Fields/Destinatario';
import IdeasPrincipalesCorreo from '../../components/Form/Fields/IdeasPrincipalesCorreo';
import LongitudResponderCorreo from '../../components/Form/Fields/LongitudResponderCorreo';
import TonoMensajeApoderado from '../../components/Form/Fields/TonoMensajeApoderado';
import ResponderCorreoCardImg from '../../components/UmmIApps/Cards/ResponderCorreoCardImg.png';
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const ResponderCorreoPage = () => {
    const {
        handleBack,
        handleInitialPromptData,
        setTextoInicial, 
        promptData
    } = useActividadesContext();

    useEffect(() => {
        const init = {
            destinatario: '',
            asunto: '',
            correoOriginal: '',
            ideasPrincipales: '',
            tono: '',
            longitud: 120
        }        
        handleInitialPromptData(init, "contestar_correo");
        setTextoInicial("Esta es la propuesta que tengo para ti.  Puedes revisar y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees.");
    }, []);

    const isButtonDisabled = !(
        promptData.destinatario &&
        promptData.asunto &&
        promptData.correoOriginal &&
        promptData.ideasPrincipales
      );

    const colorIconBack = '#6A93A8'

    return (
        <>
            <UmmiaAppsLayout
                onBack={handleBack}
                imageSrc={ResponderCorreoCardImg}
                backgroundColorImage={'linear-gradient(180deg, #FFFFFF 0%, #C3D4DC 100%, #88A9B9 100%)'}
                titleColor="#6A93A8"
                title="Responder un correo"
                description="Responde a los correos que te llegan con el mensaje perfecto para comunicar tus ideas"
                colorIconBack={colorIconBack}
                isButtonDisabled={isButtonDisabled}
            >
               <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                    <Destinatario />
                </Grid>

                <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                    <Asunto />
                </Grid>

                <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                    <CorreoOriginal />
                </Grid>

                <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                    <IdeasPrincipalesCorreo />
                </Grid>
                
                <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                    <TonoMensajeApoderado />
                </Grid>

                <Grid item xs={12} lg={12} display={'flex'} flexDirection={'row'}>
                <LongitudResponderCorreo />
                </Grid>
                
            </UmmiaAppsLayout>
        </>
    );
};

export default ResponderCorreoPage;
